import React, { useEffect } from "react";
import { Box, Grid, Typography, Card, CardMedia, CardContent, Link } from "@mui/material";
import Footer from "./Footer";
import useMediaQuery from "@mui/material/useMediaQuery";



const Banking = () => {
    const isMobile = useMediaQuery("(max-width: 900px)");


    useEffect(() => {
            window.scrollTo(0, 0); // Scroll to top when component loads
          },[]);
    
        const caseStudies = [
            {
              title: "Enhancing efficiency and compliance with ServiceNow solutions",
              company: "Leading U.S. credit union company",
              description:
                "We helped a major U.S. credit union firm digitize and streamline their business processes. This helped improve the customer experience while optimizing IT operations and ensuring regulatory compliance.",
              image: "/image/financeimg.jpg",
              link: "/bankingcs1", // updated
            },
            {
              title: "Breaking down silos with ServiceNow ITBM",
              company: "Major U.S. credit union firm",
              description:
                "We built a comprehensive digital roadmap and implemented a single-platform solution to transform operational efficiencies, improve business responsiveness and support a long-term cross-functional strategy.",
              image: "/image/financeimg1.jpg",
              link: "/bankingcs2", // updated
            },
          ];

return (
    <>
      {/* First Section - Background Image */}
      <Box
  sx={{
    position: "relative",
    width: "100%",
    minHeight: "100vh", // Use minHeight instead of fixed height
    backgroundImage: `url("/image/bank1.jpg")`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    color: "white",
    overflow: "hidden", // Prevents content from spilling over
  }}
>
  {/* Dark overlay for readability */}
  <Box
    sx={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    }}
  />

  {/* Content Box */}
  <Box
    sx={{
      position: "relative",
      maxWidth: "700px",
      marginLeft: { xs: "3%", md: "8%" },
      marginTop: { xs: "40%", md: "15%" }, // Reduce margin to avoid overflow
      zIndex: 1,
      padding: 4,
      
    }}
  >
    <Typography 
      variant="h3" 
      sx={{ 
        fontWeight: "bold", 
        mb: 2, 
        fontSize: { xs: "42px", md: "60px" }, // Reduce size slightly for better fit
      }}
    >
    Banking & Finance
    </Typography>
    <Typography 
      variant="body1" 
      sx={{ 
        fontSize: { xs: "18px", md: "18px" }, 
        maxWidth: "100%", 
        wordBreak: "break-word", 
        lineHeight: 1.5, 
      }}
    >
    Tech Informatic Solutions provides mobile banking app development services. Our experts create and build applications that allow customers to transfer funds, make payments, and make other financial transactions using mobile devices. We provide banking app development services for a variety of platforms, including native Android, iOS, and cross-platform hybrid apps, as well as the development of custom mobile banking app services.  </Typography>
  </Box>
</Box>



{/* 2nd Section  */}
<Box sx={{   background: "linear-gradient(to right, #E0F7FA, #B2EBF2, #80DEEA)",width: "100%", padding: "40px 0" }}>
    <Box
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: "center",
          justifyContent: "center",
          width: isMobile ? "100%" : "90%",
          padding: isMobile ? "30px 15px" : "50px 50px",
          gap: "50px",
          boxSizing: "border-box",
          margin: "0 auto",
          minHeight: isMobile ? "auto" : "80vh",
          paddingTop: isMobile ? "100px" : "50px",
          marginBottom: isMobile ? "-20px" : "-100px",
          background: "radial-gradient(circle, #1F6788,#161623)",
          zIndex: 1,
          boxShadow: `
          0px 12px 25px rgba(0, 0, 0, 0.6),  
          inset 0px 10px 20px rgba(255, 255, 255, 0.15),
          inset 0px -10px 30px rgba(0, 0, 0, 0.7),
          inset 10px 0px 20px rgba(0, 0, 0, 0.5), 
          inset -10px 0px 20px rgba(255, 255, 255, 0.2)
        `,
        //  top:"-50px",
         // backgroundColor:"grey"
          
        }}
        
      >
  {/* Left Content */}
  <Box
    sx={{
      flex: 1,
      textAlign: isMobile ? "center" : "left",
      margin: "0px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      
    }}
  >
    <Typography
      variant="h3"
      sx={{
        fontSize: isMobile ? "50px" : "60px", // Reduce heading size for mobile
        color:"white",
        marginTop:isMobile ?"10px":"-70px",
        
      }}
      mb={8}
    >
      Embrace the future boldly
    </Typography>

    <Typography variant="body1" sx={{ marginTop: 2, fontSize: "18px", color: "white" }}>
    Tech Informatic Solutions is your ally for the journey. We empower banks to modernize, transform, and innovate, pushing boundaries to redefine the financial landscape. Your priorities are our command. We're committed to your journey every step of the way, ensuring our promises are not just made, but kept.
    </Typography>
    
    <Typography variant="body1" sx={{ marginTop: 2, fontSize: "18px", color: "white" }}>
    Tech Informatic Solutions is your partner to boldly redefine.  </Typography>
      </Box>

  {/* Right Image */}
  <Box
    sx={{
      flex: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      margin: "0px",
      minHeight: "auto", // Prevents height issues
      marginTop: isMobile ? "50px" : "0px", // Reduced for better alignment
    }}
  >
    <img
      src="/image/financial.jpg"
      alt="About Us"
      style={{
        width: isMobile ? "90%" : "80%",
        maxHeight: "100%",
        objectFit: "cover",
        borderRadius: "10px",
        boxShadow: `
          0px 12px 25px rgba(0, 0, 0, 0.6),  
          inset 0px 10px 20px rgba(255, 255, 255, 0.15),
          inset 0px -10px 30px rgba(0, 0, 0, 0.7),
          inset 10px 0px 20px rgba(0, 0, 0, 0.5), 
          inset -10px 0px 20px rgba(255, 255, 255, 0.2)
        `,
      }}
    />
  </Box>
</Box>
</Box>

{/* 3rd section */}
<Box sx={{   background: "linear-gradient(to right, #E0F7FA, #B2EBF2, #80DEEA)", width: "100%", padding: "40px 0" }}>
<Box sx={{ px: { xs: 2, md: 10 }, py: 8 }} >
      {/* Title Section */}
      <Typography variant="h3" color="black" fontWeight="bold" gutterBottom  mb={4} mt={8}>
        Case Studies
      </Typography>
      <Typography variant="body1" sx={{  fontSize: "18px", color: "black" }}  mb={10}>
      Read how companies in the financial services industry solved their challenges by partnering with Tech Informatic Solutions.
      </Typography>

      <Grid container spacing={4} >
  {caseStudies.map((item, index) => (
    <Grid item xs={12} md={6} key={index} sx={{ display: "flex" }}>
      <Card
        elevation={0}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          background: "radial-gradient(circle, #1F6788,#161623)",
          color: "white",
          border: "1px solid #eee",
          height: "100%",
          width: "100%",
          minHeight: 550, // ✅ Equal height
          boxShadow: `
            0px 12px 25px rgba(0, 0, 0, 0.6),  
            inset 0px 10px 20px rgba(255, 255, 255, 0.15),
            inset 0px -10px 30px rgba(0, 0, 0, 0.7),
            inset 10px 0px 20px rgba(0, 0, 0, 0.5), 
            inset -10px 0px 20px rgba(255, 255, 255, 0.2)
          `,
        }}
      >
        <CardMedia
          component="img"
          height="350"
          image={item.image}
          alt={item.title}
        />

        <CardContent
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Typography
              variant="caption"
              sx={{ color: "#1976d2", fontWeight: "bold" }}
            >
              {item.company}
            </Typography>

            <Typography
              variant="h6"
              color="white"
              fontWeight="bold"
              mt={1}
            >
              {item.title}
            </Typography>

            <Typography
              variant="body2"
              mt={1}
              color="white"
              sx={{ flexGrow: 1 }}
            >
              {item.description}
            </Typography>
          </Box>

          <Link
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            sx={{ mt: 2, fontWeight: "bold", color: "#90caf9" }}
          >
            Read the case study ↗
          </Link>
        </CardContent>
      </Card>
    </Grid>
  ))}
</Grid>

    </Box>
    </Box>




   
<Footer/>
    </>
  );
};
export default Banking;